import { render, staticRenderFns } from "./ShowRepresentatives.vue?vue&type=template&id=4a9dde2e&scoped=true"
import script from "./ShowRepresentatives.vue?vue&type=script&lang=js"
export * from "./ShowRepresentatives.vue?vue&type=script&lang=js"
import style0 from "./ShowRepresentatives.vue?vue&type=style&index=0&id=4a9dde2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dde2e",
  null
  
)

export default component.exports